// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YNrj9","textarea":"styles_textarea__3mH3b"};